// ajax and loading actions
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';

// Auth actions
export const AUTH_INITIALIZATION_DONE = 'AUTH_INITIALIZATION_DONE';
export const AUTH_LOGGED_IN_SUCCESS = 'AUTH_LOGGED_IN_SUCCESS';
export const AUTH_LOGGED_OUT_SUCCESS = 'AUTH_LOGGED_OUT_SUCCESS';

// User actions
export const USER_CREATED_SUCCESS = 'USER_CREATED_SUCCESS';
export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS';
export const USER_IS_ADMIN_SUCCESS = 'USER_IS_ADMIN_SUCCESS';
export const SET_CONTRACT_INFO = 'SET CONTRACT INFO'
export const SET_TEACHER_INFO = 'SET TEACHER INFO'
export const RESET_CONTRACT_INFO = 'RESET CONTRACT INFO'
export const RESET_TEACHER_INFO = 'RESET TEACHER INFO'





// WEBPACK FOOTER //
// ./src/actions/actionTypes.js